import CloseButton from '../CloseButton/CloseButton';

type SidebarHeaderProps = {
  isOpen?: boolean;
  onClose?: () => void;
};

const SidebarHeader = ({ isOpen, onClose }: SidebarHeaderProps) => {
  return (
    <>
      {isOpen && onClose && (
        <div className="pl-6 pt-6 lg:hidden">
          <CloseButton onClick={() => onClose && onClose()} />
        </div>
      )}
    </>
  );
};

export default SidebarHeader;
